import React from 'react';
import { useBuild } from '../../contexts/BuildContext';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'net_pnl_usd', label: 'net_pnl_usd' },
  { id: 'realized_pnl_usd', label: 'realized_pnl_usd' },
  { id: 'total_buy_volume_usd', label: 'total_buy_volume_usd' },
  { id: 'total_sell_volume_usd', label: 'total_sell_volume_usd' },
  { id: 'trade_count', label: 'trade_count' },
  { id: 'tokens_traded', label: 'tokens_traded' },
  { id: 'win_rate', label: 'win_rate' },
  { id: 'true_win_rate', label: 'true_win_rate' },
  { id: 'closed_positions', label: 'closed_positions' },
  { id: 'avg_trade_size_usd', label: 'avg_trade_size_usd' },
  { id: 'largest_trade_usd', label: 'largest_trade_usd' },
  { id: 'last_trade_time', label: 'last_trade_time' },
  { id: 'first_trade_time', label: 'first_trade_time' },
  { id: 'updated_at', label: 'updated_at' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'user_ids', label: 'Wallet / Chain / Tokens' },
  { id: 'date', label: 'Date Range' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
  { id: 'author_in_app_users', label: 'In-App Users (your pushed wallets)' },
];

const NotificationHyperliquidWalletsQuery = () => {
  const { selectedIndex } = useBuild();
  return (
    <QueryModes
      source={selectedIndex}
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
    />
  );
};

export default NotificationHyperliquidWalletsQuery;
